type ExecutingRequests = {
    [key: string]: AbortController;
};

const currentExecutingRequests: ExecutingRequests = {};

export { currentExecutingRequests };
